import React from "react";
import { Button, InlineLoading } from "carbon-components-react";

const SubmitButton = ({ children, type, submitting, onClick, props }) => {
  if (!type) type = "submit";
  return (
    <Button type={type} disabled={submitting} onClick={onClick} {...props} >
      {submitting ? <InlineLoading description="Saving..." /> : <>{children}</>}
    </Button>
  );
};

export default SubmitButton;
